<template>
  <div>
    <h5>{{$t('reportFields')}}</h5>
    <custom-fields :campaign="campaign" :is-output-data="true" title="campaignReportFields"></custom-fields>
  </div>
</template>

<script>
import CustomFields from "./CustomFields";

export default {
  components: {CustomFields},
  props: ['campaign'],
  data() {
    return {
      defaultFormModel: {},
      data: null
    }
  },
  mounted() {
    if (this.campaign) {
      this.formModel = this.campaign;
    }
  },
  i18n: {
    messages: {
      en: {
        reportFields: "Report fields",
      },
      vi: {
        reportFields: "Thông tin báo cáo",
      }
    }
  },

}
</script>
